import { RootState } from '@/redux/store';
import { useSelector } from 'react-redux';

export const getDealerDetails = () =>
  useSelector((state: RootState) => state.dealer.dealerDetails);
export const getTransferCount = () =>
  useSelector((state: RootState) => state.dealer.transferCount);
export const getDealerLoading = () =>
  useSelector((state: RootState) => state.dealer.loading);
// export const getBusinessDetailsEdited = () => useSelector((state: RootState) => state.dealer.businessDetailsEdited);
export const getIsEZCheckForTransferCreationInProgress = () => useSelector((state: RootState) => state.dealer.isEZCheckForTransferCreationInProgress);
export const getezCheckStatusTransferCreation = () => useSelector((state: RootState) => state.dealer.ezCheckStatusTransferCreation);
export const getTotalTransfersCount = () => useSelector((state: RootState) => state.dealer.totalTransfersCount);
export const getEzCheckErrorTransferCreation = () => useSelector((state: RootState) => state.dealer.ezCheckTransferCreationError);
export const getSequalizeValidationError = () => useSelector((state: RootState) => state.dealer.sequalizeValidationError);
export const getIsTransferCreationAllowed = () =>  useSelector((state: RootState) => state.dealer.isTransferCreationAllowed);
export const getIsPreferredLicense = () =>  useSelector((state: RootState) => state.dealer.isPreferredLicense);
export const getIsLicenseRemoved = () =>  useSelector((state: RootState) => state.dealer.isLicenseRemoved);
export const getIsEmailNotFoundLoading = () =>  useSelector((state: RootState) => state.dealer.isEmailNotFoundLoading);
export const getOcrStepFunctionStatus = () =>  useSelector((state: RootState) => state.dealer.ocrStepFunctionStatusV2);
export const getIsOCRLoading = () =>  useSelector((state: RootState) => state.dealer.isOCRLoading);
export const getIsManualReviewLoading = () =>  useSelector((state: RootState) => state.dealer.isManualReviewLoading);
export const getIsManualReviewRequested = () =>  useSelector((state: RootState) => state.dealer.isManualReviewRequested);
export const getIsEditable = () =>  useSelector((state: RootState) => state.dealer.isEditable);



